<template>
	<div class="bg-gray-50">
		<ContainedSection
			:has-padding="false"
			:has-background="true"
			background-color="bg-white"
		>
			<TwoColumns
				:has-padding-first-column="true"
				first-column-class="order-last lg:order-none"
			>
				<template #first>
					<BreadcrumbNavigation :crumbs="crumbs" />

					<h1 class="mt-8">Come work with us</h1>
					<div class="mt-8 space-y-5 text-lg text-gray-575">
						<p>
							We are carbar, a digitally-led, customer-focused
							automotive start-up – pioneering a no-fuss way to
							drive.
						</p>
						<p>
							Our market-leading car subscription service provides
							members with exclusive access to a range of
							fully-serviced quality new and used cars. Customers
							have complete peace of mind knowing their car is
							fully insured, always under warranty, maintained,
							and serviced for the duration of their subscription.
						</p>
						<p>
							Customers can swap or stop their subscription with
							just two weeks’ notice, even make additional
							payments to own it outright. It’s never been easier
							to drive what you want, when you want.
						</p>
					</div>
					<div class="mt-8">
						<DoubleCta :is-stacked="false">
							<template #primary>
								<CarbarLink
									:href="'https://www.seek.com.au/Carbar-Autos-jobs/at-this-company'"
									class="w-full"
									:underline="false"
								>
									<CarbarButton :min-width="`min-w-full`">
										Search open jobs
									</CarbarButton>
								</CarbarLink>
							</template>
							<template #secondary>
								<CarbarLink href="mailto:People@carbar.com.au">
									<CarbarButton :is-outline="true">
										People@carbar.com.au
									</CarbarButton>
								</CarbarLink>
							</template>
						</DoubleCta>
					</div>
				</template>
				<template #second>
					<div class="h-full">
						<div class="flex h-full items-center">
							<CarbarImage
								image="img/careers/hero-careers.webp"
								alt-text="Careers heading image"
							/>
						</div>
					</div>
				</template>
			</TwoColumns>
		</ContainedSection>

		<ContainedSection :has-background="true">
			<OurMission />
		</ContainedSection>

		<ContainedSection
			:has-background="true"
			:has-padding="false"
			background-color="bg-white"
		>
			<TwoColumns
				columns-order="flex-col lg:flex-row"
				second-column-class="contained-section order-first lg:order-none"
			>
				<template #first>
					<div class="h-full">
						<div class="flex h-full items-end">
							<CarbarImage
								image="img/careers/img-enjoymarketlead.webp"
								alt-text="Careers heading image"
							/>
						</div>
					</div>
				</template>
				<template #second>
					<h2>Enjoy market-leading employee benefits</h2>
					<TickList
						:items="items"
						class="lg:space-y-2"
						:items-center="''"
					/>
					<div class="mt-8">
						<DoubleCta :is-stacked="false">
							<template #primary>
								<CarbarLink
									:href="'https://www.seek.com.au/Carbar-Autos-jobs/at-this-company'"
									class="w-full"
									:underline="false"
								>
									<CarbarButton>
										Search open jobs
									</CarbarButton>
								</CarbarLink>
							</template>
							<template #secondary>
								<CarbarLink href="mailto:People@carbar.com.au">
									<CarbarButton :is-outline="true">
										People@carbar.com.au
									</CarbarButton>
								</CarbarLink>
							</template>
						</DoubleCta>
					</div>
				</template>
			</TwoColumns>
		</ContainedSection>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TickList from '@/components/lists/TickList.vue'
import DoubleCta from '@/components/buttons/DoubleCta.vue'
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import OurMission from '@/components/about-us/OurMission.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'

const crumbs = [
	{
		title: 'Home',
		url: '/',
	},
	{
		title: 'About Us',
		url: '/about-us',
	},
	{
		title: 'Careers',
	},
]

const items = [
	{
		label: 'Employee Assistance Program',
	},
	{
		label: 'carbar discounts',
	},
	{
		label: 'Salary sacrifice car subscription',
	},
	{
		label: 'Supportive team environment',
	},
	{
		label: 'Healthy and genuine work/life balance',
	},
]
</script>
